import heroImg from "../assets/hero-1-editied.png";
import { motion } from "framer-motion";

// Variants for Hero
const containerVars = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
    },
  },
};

const subContainerVars = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.7,
    },
  },
};

const heroItem = {
  initial: { opacity: 0, x: -100 },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};
const heroItemDelay = {
  initial: { opacity: 0, x: -100 },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.7,
      delay: 2.5,
    },
  },
};

const Hero = () => {
  return (
    <div id="home" className="hero container">
      <div aria-hidden="true" className="float-blob float-blob--1"></div>
      <div aria-hidden="true" className="float-blob float-blob--2"></div>
      <div aria-hidden="true" className="float-blob float-blob--3"></div>
      <div aria-hidden="true" className="float-blob float-blob--4"></div>
      <div aria-hidden="true" className="float-blob float-blob--5"></div>
      <div aria-hidden="true" className="float-blob float-blob--6"></div>
      <div aria-hidden="true" className="float-blob float-blob--7"></div>
      <motion.div
        className="hero-content"
        variants={containerVars}
        initial="initial"
        animate="animate"
      >
        <motion.h1 variants={heroItem} className="heading-primary">
          Hi, I'm <span>Rehan!</span>
          <br />
          Full Stack Developer
        </motion.h1>
        <motion.p variants={heroItem} className="hero-text">
          I'm a passionate <span>Full Stack</span> Software Engineer
        </motion.p>
        <motion.div variants={subContainerVars} className="btn-group">
          <motion.button
            variants={heroItem}
            onClick={() => (window.location.hash = "#projects")}
            className="btn btn-primary"
          >
            View projects
          </motion.button>
          <motion.button
            variants={heroItem}
            onClick={() => (window.location.hash = "#contact")}
            className="btn btn-primary btn-ghost"
          >
            Get connected
          </motion.button>
        </motion.div>

        <motion.ul variants={heroItemDelay} className="hero-info__list">
          <li className="hero-info--item">
            <a href="mailto:rehanshafqat2004@gmail.com">Email</a>
          </li>
          <li className="hero-info--item">
            <a href="https://github.com/RehanShafqat/" target="blank">
              github
            </a>
          </li>
        </motion.ul>
      </motion.div>

      <div className="hero-img">
        <img src={heroImg} alt="hero" />
      </div>
    </div>
  );
};

export default Hero;
